export default __webpack_public_path__ + "static/messages-flag-21226fcf4035b949f3cf72bbd673c49b88171f7c1a7795e9531fc112f1899267.jpg";